/**
 * @generated SignedSource<<02c3279b01517f35200157f7cff6b4b0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespHeroCarouselRequestMoreImages_item$data = {
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"SharedContactDealerWrapper_item">;
  readonly " $fragmentType": "PdpRespHeroCarouselRequestMoreImages_item";
};
export type PdpRespHeroCarouselRequestMoreImages_item$key = {
  readonly " $data"?: PdpRespHeroCarouselRequestMoreImages_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespHeroCarouselRequestMoreImages_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespHeroCarouselRequestMoreImages_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedContactDealerWrapper_item"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "092c74d315099a40ad4b44ee46353114";

export default node;
